import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, watch } from 'vue'
import { FireRiskDashboardViewModel } from '../../viewmodels/FireRiskDashboard.viewmodel'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import BaseTable from '../../../../ui/components/baseTable/BaseTable.vue'
import FireOutbreakCardReactionMenu from '../FireOutbreakCardReactionMenu.vue'
import SFButton from '@/components/ui/button/Button.vue'
import FireAlertsFilter from '../FireAlertsFilter.vue'
import EmptyState from '@/@web/ui/components/EmptyState.vue'
import { useTable } from '../../../../ui/components/baseTable/composables/Table.composable'
import { FireAlertsTableHeadersFactory } from '../../factories/FireAlertsTableHeaders.factory'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireAlertsTable.view',
  setup(__props) {

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const rerender = ref(Math.random())

const {
	pageData: alerts,
	page: alertsPage,
	pageSize: alertsPageSize,
	onPageChange: alertsOnPageChange,
	sortOptions,
	handleSort,
} = useTable(vm.filteredFireOutbreakAlerts)

const tableHeaders = computed(() => [...FireAlertsTableHeadersFactory.make(sortOptions.value)])

watch(vm.mapFireOutbreaks, () => (rerender.value = Math.random()), { deep: true })

// A busca por seleção de fazendas vive na page (FireRiskDashboard.page.vue), que
// é dona do ciclo de vida do viewmodel. Aqui fica apenas o refetch do filtro de
// datas, cujo controle é renderizado nesta view.
watch([() => vm.fireAlertsFilter.value.startDate, () => vm.fireAlertsFilter.value.endData], () =>
	vm.getRecentFireOutbreaks(),
)

return { __sfc: true,vm, rerender, alerts, alertsPage, alertsPageSize, alertsOnPageChange, sortOptions, handleSort, tableHeaders, Pagination, BaseTable, FireOutbreakCardReactionMenu, SFButton, FireAlertsFilter, EmptyState }
}

})